import { Button, withStyles } from '@material-ui/core';

import { getColorTheme } from '~/src/dash/resellers/utils/importResellerConfig';

export const ModelPrimaryButton = withStyles({
  root: {
    background: getColorTheme('primaryButton'), // Background of primary buttons
    boxShadow: '0px 0px 6px ' + getColorTheme('primaryButtonShadow'), // Shadow of primary buttons
    color: '#fafafa',
    '&:hover': {
      background: getColorTheme('primaryButtonHover'), // Background of primary buttons when hover
    },
    '&:active': {
      background: getColorTheme('primaryButtonActive'), // Background of primary buttons when active
      boxShadow: 'none',
    },
    '&:disabled': {
      background: getColorTheme('primaryButtonDisabled'), // Background of primary buttons when disabled
      boxShadow: 'none',
    },
    label: {
      '&$disabled': {
        color: '#B3B3B4 !important',
      },
    },
  },
})(Button);
